<div class="error-title">
  <h1>{{ titleKey | translate }}</h1>
  <h3>{{ messageKey | translate }}</h3>
</div>
<button type="button" class="error-button htv-selectable htv-button" (click)="restartApp()">
  {{ 'PAGES.ERROR.RELOAD' | translate }}
</button>
<div class="error-message" *ngIf="error && showError">
  {{ error?.message }}
</div>
